import { GameSvc } from '../services/game.service';
import { BetSvc } from "../services/bet.service";
import { GatewaySvc } from '../services/gateway.service';
import { EventBus } from '../utilities/event.bus';
import { RulesSvc } from '../services/rules.service';
import { PaytableSvc } from "../services/paytable.service";
import storage from '../utilities/localStorage'
import { TranslationSvc } from '../services/translation.service';

class Betting {
  /** @constructor */
  constructor() {
    this.type = 'normal';

    this.ticket = {
      input: [],
      payin: 1,
      newPayin: 1,
    };

    this.numEvents = 1;
    this.maxFutureRounds = 10;
    this.system = '';
    this.random = '';
    this.updateBet = false;
    this.selectedBet = '';
    this.currentNumberOfSystems = '';
    this._subscribeEvents();
    this.name = '';
    this.shortcut = '';
    this.specialBetType = 0;
    this.actions = [];
    this.notificationDelay = 1500;
    this.eventId = 0;
    this.rebet = false;
    this.deactivateNumbersSpecialBet();

    this.shortcutBindings = {
      30: 'v',
      31: 'b',
      32: 'k',
      33: 'l',
      34: 'h',
      35: 'j',
      36: 'n',
      37: 'm',
      38: 'o',
      39: 'p',
      40: 'u',
      41: 'i',
    };
  }

  /**
   * Clear active state
   */
  clearAll(fullReset) {
    this.type = 'normal';
    this.ticket.payin = 1;
    this.ticket.newPayin = 1;
    this.numEvents = 1;
    this.system = '';
    this.name = '';
    this.shortcut = '';
    this.actions = [];
    this.notificationDelay = 1500;
    this.eventId = 0;
    this.rebet = false;
    this.currentNumberOfSystems = '';

    this.clearNumberBets();
    this.clearSpecialBets();

    // If not forced, Random selection is kept for terminal
    if (fullReset || sevenConfig.data.dp.toLowerCase() !== 'terminal') {
      this.setInitRandom();
    }
  }

  clearNumberBets() {
    this.clearInput();

    GameSvc.getGameSvc().dactivateBalls();
    this.deactivateNumbersSpecialBet();
  }

  clearSpecialBets() {
    this.specialBetType = 0;
  }

  clearUpdateBetStatus() {
    this.updateBet = false;
  }

  clearInput() {
    this.ticket.input = [];
  }

  setInitRandom() {
    // Only the terminal needs predefined random due to select button
    // Otherwise, empty selection is appropriate
    if (sevenConfig.data.dp.toLowerCase() !== 'terminal') {
      this.random = '';
    } else {
      const paytableSvc = PaytableSvc.getPaytableSvc();
      const spotNumber = GameSvc.getGameSvc().spotNumber || 10;
      let minNumbers = 1;

      for (let i = 1; i < spotNumber; i++) {
        if (paytableSvc.paytable[i + "_" + i] !== undefined) {
          minNumbers = i;
          break;
        }
      }
      this.random = minNumbers;
    }
  }

  deactivateNumbersSpecialBet() {
    this.specialBetsActiveStatus = {
      41: false,
      40: false,
    };
  }

  terminalSpecialBet(e, self, click) {
    const id = parseInt(e.target.id);
    const choice = e.choice;

    let isSpecial = true;

    if (click) {
      for (let i in self.specialBetsActiveStatus) {
        if (i == id) {
          self.specialBetsActiveStatus[i] = !self.specialBetsActiveStatus[i];

          if (!self.specialBetsActiveStatus[i]) {
            isSpecial = false;
          }

        } else {
          self.specialBetsActiveStatus[i] = false;
        }
      }
    }

    if (isSpecial) {
      const specialBets = self.specialBets;

      let sBet = {};
      for (let i in specialBets) {
        if (id === specialBets[i].id) {
          sBet = specialBets[i];
          break;
        }
      }

      // All-in bet validation
      if (sBet.id === 41 && self.ticket.input.length > GameSvc.getGameSvc().rules.maxAllInNumbers.value) {
        this.deactivateNumbersSpecialBet();
        self.type = 'normal';
        return;
      }

      if (choice) {
        self.ticket.input = choice;
      }

      self.type = 'special';
      self.name = sBet.name;
      self.actions = sBet.actions;
      self.specialBetType = sBet.id;
    } else {
      self.type = 'normal';
    }
  }

  setSpecialBets(bets) {
    const betKeys = Object.keys(bets);
    this.specialBets = {};

    for (let i = 0; i < betKeys.length; i += 1) {
      let bet = bets[betKeys[i]];

      // Don't inlcude deactivated betting
      if (!bet.value) continue;

      if (bet.id in this.shortcutBindings) {
        let delay = 3000;

        this.specialBets[this.shortcutBindings[bet.id]] = {
          name: bet.name,
          id: bet.id,
          actions: [],
          delay: delay,
          active: bet.value,
          selected: false,
        };

        for (let j = 0; j < bet.outcomes.length; j += 1) {
          let prefix = (j + 1);
          let suffix = bet.outcomes[j];
          let outcomeText = '';
          let odd = bet.odds[j] || bet.odds;

          suffix = suffix.charAt(0).toUpperCase() + suffix.substring(1, suffix.length);

          if (bet.id === 40 || bet.id === 41) {
            suffix = bet.odds[j];
            if (bet.odds[j] < 100) {
              suffix = parseFloat(suffix).toFixed(2);
            }
          }

          outcomeText = prefix + ' - ' + suffix;

          this.specialBets[this.shortcutBindings[bet.id]].actions[j] = {
            info: outcomeText,
            noPermission: true,
            odd: odd,
          };
        }
      }
    }
  }

  /**
   * Add round
   * @param bet
   * @returns {*}
   */
  resolveRoundDisplay(bet, rebet) {
    let event = GameSvc.getGameSvc().gameInfo.roundNumber;

    // check if future bet is active
    bet.event = this.numEvents > 1 ? event + '-' + (Number(event) + Number(this.numEvents - 1)) : event;

    if (rebet) {
      bet.event = bet.numEvents > 1 ? event + '-' + (Number(event) + Number(bet.numEvents - 1)) : event;
    }

    return bet;
  }

  /**
   * Set bet payin
   * @param bet {object}
   * @param serverBet {object}
   * @returns {*}
   * @private
   */
  setPayin(bet, serverBet, rebet) {
    let gameSvc = GameSvc.getGameSvc();
    let isSystem = bet.hasOwnProperty('system') && bet.system;
    let minPayin = (bet.combinations * gameSvc.rules.minCombBetAmount.value) > gameSvc.rules.minBetAmount.value ? (bet.combinations * gameSvc.rules.minCombBetAmount.value) : gameSvc.rules.minBetAmount.value;

    if (serverBet) {
      bet.payin = serverBet.amount + (serverBet.tax ? serverBet.tax : 0);
      bet.stake = serverBet.amount + (serverBet.tax ? serverBet.tax : 0);
    } else {
      let numEvents = parseInt(this.numEvents, 10);
      if (rebet) {
        numEvents = parseInt(bet.numEvents, 10);
      }

      bet.payin = isSystem ? (minPayin * numEvents) : (gameSvc.rules.minBetAmount.value * numEvents);
      bet.stake = isSystem ? (minPayin * numEvents) : (gameSvc.rules.minBetAmount.value * numEvents);
    }

    return bet;
  }

  /**
   *  Set final played bets
   *  @param {Object} serverBet
   *  @returns {Array}
   */
  finalizeTicket(serverBet, returnFinal, eventId) {
    let gameSvc = GameSvc.getGameSvc();
    let finalBets = BetSvc.getBetSvc().finalizeBet();

    if (!finalBets) {
      GatewaySvc.getGatewaySvc().showDialog({
        message: TranslationSvc.getTranslation('bet_not_valid')
      });
    }

    finalBets.forEach(finalBet => {
      this.resolveRoundDisplay(finalBet);
      this.setPayin(finalBet, serverBet);
    });

    // edit bet
    if (this.updateBet) {
      this.selectedBet = this.selectedBet || {};

      finalBets = Object.assign(this.selectedBet, finalBets[0]);

      GatewaySvc.getGatewaySvc().sendMessage('Betslip.UpdateSelectedBet', {
        bets: [finalBets],
      });

      this.clearUpdateBetStatus();

      return;
    }

    if (RulesSvc.getRulesSvc().validatePreBetslip(finalBets[0])) {
      if (finalBets[0] && finalBets[0].numEvents) {
        finalBets[0].numEvents = parseInt(finalBets[0].numEvents, 10);
      }

      if (returnFinal) {
        return finalBets[0];
      }

      GatewaySvc.getGatewaySvc().sendMessage('Betslip.AddBet', {
        bets: [finalBets[0]]
      });

      EventBus.$emit('keydown', {
        key: '+',
      });
    }
  }

  /**
   * Subscribe to events
   * @private
   */
  _subscribeEvents() {
    EventBus.$on('Betslip.BetSelected', data => {
      this.reCreateBet(data);
    });

    EventBus.$on('Config.Fetched', () => {
      this.maxSystemNumber = sevenConfig.data.config.rules.maxSystemNumber.value;
      this.setMaxFutureRounds();
    });

    EventBus.$on('Tickets.ReBet', data => {
      let isGameActive = JSON.parse(storage.getKey('isGameActive'));
      if (!isGameActive) {
        EventBus.$on('Slave.Shown', () => {
          this.reBet(data.ticket);
        });
      } else {
        this.reBet(data.ticket);
      }
    });
  }

  /**
   * Select random number
   */
  selectRandomNumbers() {
    const gameSvc = GameSvc.getGameSvc();

    while (this.ticket.input.length < this.random) {
      let number = Math.floor(Math.random() * 80) + 1;

      if (this.ticket.input.indexOf(number) < 0) {
        this.ticket.input.push(number);
        gameSvc.balls[number - 1].status = true;
      }
    }
  }

  /**
   * Rebet
   * @param {Object} ticket
   */
  reBet(ticket) {
    this.rebet = true;

    var rebets = [],
      isSystem;

    EventBus.$off('Slave.Shown');

    GatewaySvc.getGatewaySvc().sendMessage('Betslip.Clear', {
      betslipId: 'Keno'
    });

    ticket.bets.forEach(bet => {
      let title = bet.bet.title
      isSystem = bet.hasOwnProperty('system') && bet.system;
      this.eventId = bet.eventId;

      this.type = isSystem ? 'system' : 'normal';

      if (bet.type >= 30) {
        this.type = 'special';
        this.specialBetType = bet.type;
        title = sevenConfig.data.config.bets[bet.type].name;

        if (bet.type !== 41 && bet.type !== 40) {
          bet.value = bet.value + 1;
        }
      } else {
        this.specialBetType = 0;
      }
      this.ticket.input = bet.value;
      this.system = isSystem ? bet.system : '';

      let betToPush = this.finalizeTicket(bet, true, bet.eventId);
      betToPush.displayName = title;
      rebets.push(betToPush);
    });

    rebets = this.recreateFutureBets(rebets);

    rebets.forEach(bet => {
      this.resolveRoundDisplay(bet, true);
      this.setPayin(bet, false, true);
    });

    if (rebets.length) {
      GatewaySvc.getGatewaySvc().sendMessage('Betslip.ReCreate', {
        productId: 'Keno',
        ticket: ticket,
        bets: rebets,
        ticketId: 'single',
      });
    }

    this.clearAll();
  }

  /**
   * Set max. number of future rounds
   * Two properties are important - `scheduleType` & `futureBets`
   * If scheduleType is lower than futureBets than its value is applicable
   * Otherwise, futureBets is set as max. value
   */
  setMaxFutureRounds() {
    const config = sevenConfig.data.config;
    const scheduleType = parseInt(config.scheduleType.value && config.scheduleType.value.split('_')[0] || 10);
    const futureBets = parseInt(config.futureBets.value && config.futureBets.value || 10);

    this.maxFutureRounds = futureBets > scheduleType ? scheduleType : futureBets;
  }

  /**
   * Recreate future bets - same bet type and same bet value
   * Be careful when there are various same bets played for same round
   * @param bets
   * @returns {Array}
   */
  recreateFutureBets(bets) {
    var oldBets = bets;
    var newBets = {};
    var groups = {};
    var finalBets = [];
    var tmpBet;
    var sameIdBets = [];

    //Group bets by type & value
    oldBets.forEach(function (bet) {
      if (bet.hasOwnProperty('event')) {
        delete bet.event;
      }

      if (bet.hasOwnProperty('numEvents')) {
        delete bet.numEvents;
      }

      groups[bet.value + '-' + bet.betType] = groups[bet.value + '-' + bet.betType] || [];
      groups[bet.value + '-' + bet.betType].push(bet);
    });

    for (var group in groups) {
      groups[group].sort(function (a, b) {
        return a.eventId - b.eventId;
      });

      // Get bets from each group with same id and move them
      // to separate arrays in newBets object
      while (groups[group].length) {
        tmpBet = groups[group][0];

        // sameIdBets = $filter('filter')(groups[group], {eventId: tmpBet.eventId}, true);
        sameIdBets = this.getSameIdBets(groups[group], tmpBet);

        groups[group].splice(0, sameIdBets.length);

        sameIdBets.forEach(function (bet, idx) {
          newBets[group + '/' + idx] = newBets[group + '/' + idx] || [];
          newBets[group + '/' + idx].push(bet);
        });
      }
    }

    //Merge bets that were played as future to one bet
    for (var i in newBets) {
      newBets[i][0].numEvents = newBets[i][0].numEvents > 1 ? newBets[i][0].numEvents : newBets[i].length;
      finalBets.push(newBets[i][0]);
    }

    return finalBets;
  }

  getSameIdBets(group, tmpBet) {
    let sameIdBets = [];
    for (let bet in group) {
      if (group[bet].eventId === tmpBet.eventId) {
        sameIdBets.push(group[bet]);
      }
    }

    return sameIdBets;
  }

  focusNext(tabindex) {
    GatewaySvc.getGatewaySvc().sendMessage('FocusNext', [tabindex]);
  }

  /**
   * Recreate bet - used on bet update
   * @param {Object} data
   */
  reCreateBet(data) {
    this.clearAll();
    this.clearInput();

    data.bet.shortcut = '';
    let bettingType = 'normal';

    let event = (typeof data.bet.event === 'string') ? data.bet.event.split('-') : data.bet.event,
      isSystem = data.bet.hasOwnProperty('system') && data.bet.system;

    if (this.selectedBet.uid && data.bet.uid && this.selectedBet.uid !== data.bet.uid) {
      this.updateBet = true;
    } else {
      this.updateBet = !this.updateBet;
    }

    this.selectedBet = data.bet;
    this.numEvents = Array.isArray(event) ? (event[1] - event[0]) + 1 : 1;
    this.system = isSystem ? data.bet.system : '';
    this.type = data.bet.type || isSystem ? 'system' : 'normal';
    this.name = data.bet.displayName;

    if (data.bet.type === null || (data.bet.type < 30 || data.bet.type > 39)) {
      GameSvc.getGameSvc().activateBalls(data.bet.value);
    } else {
      bettingType = 'special';
      this.clearNumberBets();
    }

    if (sevenConfig.data.dp.toLowerCase() === 'terminal') {
      EventBus.$emit("Keno.SwitchBettings", bettingType);
      if (data.bet.type === 40 || data.bet.type === 41) {
        this.terminalSpecialBet({target: { id: data.bet.type } }, this, 'click');
      } else if (data.bet.type >= 30 && data.bet.type <= 39) {
        EventBus.$emit("Keno.SelectSpecialBetting", { id: data.bet.type }, data.bet.value);
      }
    }

    let key = isSystem ? 's' : '+';

    if (!data.bet.shortcut) {
      for (let i in this.specialBets) {
        if (data.bet.id === this.specialBets[i].id) {
          data.bet.shortcut = i;
          break;
        }
      }
    }

    if (data.bet.shortcut) {
      key = data.bet.shortcut;
    }

    EventBus.$emit('keydown', {
      key: key,
    });

    if (data.bet.numEvents > 1) {
      EventBus.$emit('keydown', {
        key: 'f',
      });
    }

    if (!this.updateBet) {
      this.clearAll();
      this.clearUpdateBetStatus();

      EventBus.$emit('keydown', {
        key: '+',
      });

      return;
    }

    // All bet components clear  ticket.input before mounting
    // This has to be at end of this function
    setTimeout(() => {
      if (sevenConfig.data.dp.toLowerCase() === 'terminal') {
        if (data.bet.id < 30 || data.bet.id > 39) {
          this.ticket.input = data.bet.value;
        }
      } else {
        if (data.bet.id in this.shortcutBindings) {
          if (data.bet.id === 40 || data.bet.id === 41) {
            this.ticket.input = data.bet.value;
          } else {
            this.ticket.input = [data.bet.value + 1];
          }
        } else {
          this.ticket.input = data.bet.value;
        }
      }
    }, 0);
  }
}

export default Betting;



// WEBPACK FOOTER //
// betting.js